import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/useAuth';
import { Button } from '../components/ui/Button';

export function ProfilePage() {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading, profile, login } = useAuth();

  if (isLoading) {
    return <section className="page"><p>{t('common.loading')}</p></section>;
  }

  if (!isAuthenticated) {
    return (
      <section className="page">
        <h1>{t('profile.title')}</h1>
        <div className="card">
          <p>{t('auth.notAuthenticated')}</p>
          <Button
            onClick={() => {
              login('/me');
            }}
          >
            {t('auth.login')}
          </Button>
        </div>
      </section>
    );
  }

  return (
    <section className="page">
      <h1>{t('profile.title')}</h1>
      <dl className="card definition">
        <dt>{t('profile.email')}</dt>
        <dd>{profile?.email ?? '—'}</dd>
        <dt>{t('profile.username')}</dt>
        <dd>{profile?.name ?? '—'}</dd>
        <dt>{t('profile.subject')}</dt>
        <dd><code>{profile?.sub ?? '—'}</code></dd>
      </dl>
    </section>
  );
}
